import { useOutletContext } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';

import { TopPlayers } from '@sorare/gameplay/src/components/topPlayers/TopPlayers';
import { Filters } from '@sorare/gameplay/src/components/topPlayers/TopPlayers/TopPlayersFilters/types';

import { PageParams } from './__generated__/routeParams';

const TopPlayersPage = () => {
  const { fixture, eventType } = useTypedParams<PageParams>();
  const { fixture: fixtureFromOutletContext, filters } = useOutletContext<{
    fixture: string;
    filters: Filters;
  }>();

  return (
    <TopPlayers
      filters={filters}
      eventType={eventType as So5FixtureEvent}
      fixture={fixtureFromOutletContext || fixture}
    />
  );
};

export default TopPlayersPage;
